import gql from 'graphql-tag';

export const GET_CLIENT_TOKEN = gql`
  query getClientToken {
    clientToken
  }
`;
